import ServiceCompany from '../../components/service-company/ServiceCompany';

export function ServicePage() {
  return <ServiceCompany></ServiceCompany>;
}
